"use strict";
import BtnBase from './btnbase';

class BtnPageTop extends BtnBase{
	constructor($con){
		super($con);
	}
	
	init(){
		this.$con.empty();
		let h = '';
		h += '<span class="l1"></span>';
		h += '<span class="l2"></span>';
		this.$con.append(h);
		this.out();
	}
	
	responsiveHandler(){
		super.responsiveHandler();
		this.$con.find('.l1').velocity('stop').removeAttr('style').velocity({rotateZ:45,translateX:0},{duration:1});
		this.$con.find('.l2').velocity('stop').removeAttr('style').velocity({rotateZ:-45,translateX:0},{duration:1});
	}
	
	over(){
		super.over();
		this.$con.find('.l1').velocity('stop')
			.velocity({rotateZ:60,translateX:-4},{duration:80});
		this.$con.find('.l2').velocity('stop')
			.velocity({rotateZ:-60,translateX:4},{duration:80});
	}
	
	out(){
		super.out();
		this.$con.find('.l1').velocity('stop')
			.velocity({rotateZ:45,translateX:0},{duration:80});
		this.$con.find('.l2').velocity('stop')
			.velocity({rotateZ:-45,translateX:0},{duration:80});
	}
	
	click(){
		super.click();
		$('html').velocity('scroll', { duration: 500, easing: "swing" });
	}

}

export default BtnPageTop;


// WEBPACK FOOTER //
// ./js/btn/btnpagetop.js